import { Component, EventEmitter, inject, OnInit, Output, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NavStateService } from '../../../services/nav-state.service';

@Component({
  selector: 'app-verification-summary',
  standalone: false,
  templateUrl: './verification-summary.html',
  styleUrl: './verification-summary.less',
})
export class VerificationSummary implements OnInit{
  private router = inject(Router);
  private navState = inject(NavStateService);
  private route = inject(ActivatedRoute);
  isProcessing = signal(false);
  @Output() editRequested = new EventEmitter<any>();

  ngOnInit(){
    this.navState.setCurrentTitle('Verification Summary');
    this.navState.setShowBackButton(false);
  }

  startVerification(): void {
    this.isProcessing.set(true);
    console.log('Initiating verification workflow...');
    this.editRequested.emit();
  //  const currentUrl: string = this.router.url; 
    
  //   console.log('Actual URL String:', currentUrl);
  //   this.router.navigate(['verification-form'],{
  //     relativeTo:this.route
  //   })
  }

  openHelp(): void {
    console.log('Opening help documentation...');
  }
}
